export default "__VITE_ASSET__CihX4Zo8__"